import { render, staticRenderFns } from "./ModalAcreditaciones.vue?vue&type=template&id=66ce993e"
import script from "./ModalAcreditaciones.vue?vue&type=script&lang=js"
export * from "./ModalAcreditaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports